class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.index = this.dataset.megaMenu;
    this.link = document.querySelector(`[data-mega-link="${this.index}"]`);
    this.megaMenuBackdrop = document.querySelector(`[data-mega-menu-backdrop="${this.index}"]`);
    this.menu_elements = this.querySelectorAll('[data-mega-menu-item]');

    this.init();
  }

  init() {
    this.link.addEventListener('click', () => {
      if (this.classList.contains('active')) {
        this.closeMegaMenu();
        this.link.classList.remove('active');
      } else {
        this.openMegaMenu();
        this.link.classList.add('active');
      }
      window.addEventListener('click', this.windowClickHandler.bind(this));
      this.addEventListener('mouseleave', this.mouseLeaveHandler.bind(this));
    });
    this.link.addEventListener('keyup', (event) => this.handleMenuButtonADA(event));
    this.menu_elements.forEach((el) => el.addEventListener('keyup', (event) => this.handleMenuElsADA(event)));
  }

  handleMenuButtonADA(event) {
    const { key } = event;
    if (key === 'Escape' && this.classList.contains('active')) {
      this.link.click();
      this.menu_elements.forEach((el) => (el.tabIndex = '-1'));
    } else if (key === 'Enter' && this.classList.contains('active') == true) {
      this.menu_elements.forEach((el) => (el.tabIndex = '0'));
      this.menu_elements.item(0).focus();
    }
  }

  handleMenuElsADA(event) {
    const { key } = event;
    if (key === 'Escape' && this.classList.contains('active')) {
      this.link.click();
      this.link.focus();
      this.menu_elements.forEach((el) => (el.tabIndex = '-1'));
    }
  }

  openMegaMenu() {
    this.classList.add('active');
    this.megaMenuBackdrop.classList.add('active');
  }

  closeMegaMenu() {
    this.classList.remove('active');
    this.megaMenuBackdrop.classList.remove('active');
  }

  mouseLeaveHandler(e) {
    let reEntered = false;
    const setReEntered = () => (reEntered = true);
    this.addEventListener('mouseenter', setReEntered);
    setTimeout(() => {
      if (!reEntered) {
        this.closeMegaMenu();
        this.link.classList.remove('active');
      }
      this.removeEventListener('mouseenter', setReEntered);
    }, 500);
  }

  windowClickHandler(event) {
    const path = event.path || (event.composedPath && event.composedPath());
    if (!path.includes(this) && !path.includes(this.link)) {
      this.closeMegaMenu();
      this.link.classList.remove('active');
      window.removeEventListener('click', this.windowClickHandler.bind(this));
    }
  }
}
if (!customElements.get('mega-menu')) customElements.define('mega-menu', MegaMenu);
